var map = {
	"./img_0.png": 507,
	"./img_1.png": 508,
	"./img_10.png": 509,
	"./img_2.png": 510,
	"./img_3.png": 511,
	"./img_4.png": 512,
	"./img_5.png": 513,
	"./img_6.png": 514,
	"./img_7.png": 515,
	"./img_8.png": 516,
	"./img_9.png": 517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;